export default __webpack_public_path__ + "static/media/grid.015.fb1aedb2.jpeg";